import { PlayerRef } from '@remotion/player';
import React, { useEffect } from 'react';
import { FEATURE_CLIP_TRIM_SHORTCUTS } from '../flags';
import { isEventTargetInputElement } from '../utils/is-event-target-input-element';
import { useSelectedItems, useWriteContext } from '../utils/use-context';
import {
  applyTimelineEdit,
  type TimelineEdit,
} from '@waka/compat/timeline-editing';

export const ClipTrimShortcuts: React.FC<{
  playerRef: React.RefObject<PlayerRef | null>;
  skimFrame: number | null;
  isSkimming: boolean;
  hoveredItemId: string | null;
}> = ({ playerRef, skimFrame, isSkimming, hoveredItemId }) => {
  const { selectedItems } = useSelectedItems();
  const { setState } = useWriteContext();
  useEffect(() => {
    if (!FEATURE_CLIP_TRIM_SHORTCUTS) return;
    const onKey = (event: KeyboardEvent) => {
      if (
        event.isComposing ||
        event.metaKey ||
        event.ctrlKey ||
        event.altKey ||
        isEventTargetInputElement(event)
      )
        return;
      const operation: TimelineEdit | null =
        event.code === 'KeyE'
          ? 'split'
          : event.code === 'KeyQ'
            ? 'trim-left'
            : event.code === 'KeyW'
              ? 'trim-right'
              : null;
      if (!operation) return;
      const frame =
        isSkimming && skimFrame !== null
          ? skimFrame
          : playerRef.current?.getCurrentFrame();
      const targets =
        isSkimming && hoveredItemId ? [hoveredItemId] : selectedItems;
      if (frame === undefined || targets.length === 0) return;
      event.preventDefault();
      setState({
        update: (state) => applyTimelineEdit(state, targets, frame, operation),
        commitToUndoStack: true,
      });
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [
    playerRef,
    skimFrame,
    isSkimming,
    hoveredItemId,
    selectedItems,
    setState,
  ]);
  return null;
};
